import * as dayjs from 'dayjs';
import { UserRoles } from '../users';

export interface SimCardState {
    loading: number;
    simCards: SimCard[];
    totalCount: number;
}

export enum SimCardActionTypes {
    LOADING = '@liebherr/sim_cards/loading',
    DECREASE_LOADING = '@liebherr/sim_cards/decrease_loading',
    ADD_SIM_CARD = '@liebherr/sim_cards/add_sim_card',
    ADDED_SIM_CARD = '@liebherr/sim_cards/added_sim_card',
    LOAD_SIM_CARDS = '@liebherr/sim_cards/load_sim_cards',
    LOADED_SIM_CARDS = '@liebherr/sim_cards/loaded_sim_cards',
    DELETE_SIM_CARD = '@liebherr/sim_cards/delete_sim_card',
    DELETED_SIM_CARD = '@liebherr/sim_cards/deleted_sim_card',
    UPDATE_SIM_CARD = '@liebherr/sim_cards/update_sim-card',
    UPDATED_SIM_CARD = '@liebherr/sim_cards/updated_sim_card',
}

export const simCardFeatureKey = 'simCards';

export class SimCard {
    iccid?: string;
    expirationDate?: string;
    routerId?: string;
    craneId?: string;
    customerCard: boolean;
    constructor(dto: any) {
        this.iccid = dto.iccid;
        this.expirationDate = dto.expirationDate ? dayjs(dto.expirationDate).toString() : undefined;
        this.routerId = dto.routerId;
        this.craneId = dto.craneId;
        this.customerCard = dto.customerCard || false;
    }
}

export enum SimCardMenuActions {
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
}

export function getSimCardsPermissions(actionType: SimCardActionTypes) {
    switch (actionType) {
        case SimCardActionTypes.LOAD_SIM_CARDS: {
            return [UserRoles.LCO_GET_1];
        }
        case SimCardActionTypes.UPDATE_SIM_CARD: {
            return [UserRoles.LCO_PUT_2];
        }
        case SimCardActionTypes.DELETE_SIM_CARD: {
            return [UserRoles.LCO_DELETE_2];
        }

        default: {
            return [];
        }
    }
}
